import type { AbTest } from '@/shared/lib/AbTests';
import type { DestinationKind } from '@/shared/model';

export enum TrackingEvent {
  IntelligentSearch = 'trackIntelligentSearch',
  SearchStart = 'trackSearchStart',
  SearchResults = 'trackSearch',
  SearchFilters = 'trackSearchFilters',
  Calendar = 'trackCalendar',
  EmptySearchStart = 'trackEmptySearchStart',
  SerpHotelPositions = 'trackSerpHotelPosition',
}

export type TrackingData = Record<string, unknown>;

export type DataLayerEvent = Record<string, unknown>;

export type TrackingSource = 'mobweb' | 'desktop';

export interface TrackingMeta {
  ga_id: string | number;
  ya_id: string | number;
  domain: string;
  source: TrackingSource | null;
  timestamp: string;
  ab_tests: AbTest[] | null;
  customer_hash: string | null;
}

interface TrackedDestination {
  id: number;
  type: DestinationKind;
}

export interface IntelligentSearchTracking {
  inputValue: string;
  selectedData: TrackedDestination;
}
